import { render } from "./HomeSectionFour.vue?vue&type=template&id=52081e72&scoped=true"
import script from "./HomeSectionFour.vue?vue&type=script&lang=js"
export * from "./HomeSectionFour.vue?vue&type=script&lang=js"

import "./HomeSectionFour.vue?vue&type=style&index=0&id=52081e72&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52081e72"

export default script